import React from 'react';
import './PartNoteFooter.scss';
import { openTroublesFormForQuiz, setSelectedTroubles } from '../../Troubles/troubleslice';
import { changeFoldererView } from '../noteslice';
import { idNoteAddFilesLoad } from '../../../Admin/adminSlice';

const PartNoteFooter = (props) => {
    const {dispatch} = props;

    const onClickTroubles = () =>{
        const item = {
            selectedNoteId: props.selectedNoteId,
            selectedPart: props.part,
        }

        dispatch(setSelectedTroubles(item));
        dispatch(openTroublesFormForQuiz());
    }
    // SHOW FOLDERER
    const onClickFolderer = () => {
        dispatch(idNoteAddFilesLoad(props.selectedNoteId));
        dispatch(changeFoldererView());
    }


    // COUNT TROUBLES
    const countTroubles = () => {
        let result= 0;
        if (props.dataTroubles) {
        props.dataTroubles.forEach(item => {
//console.log(typeof(item.note_id));
//console.log(typeof(props.selectedNoteId));
//console.log(typeof(item.note_part));
//console.log(typeof(props.part));

            if((item.note_id === Number(props.selectedNoteId)) && (item.note_part === props.part)) {
                result =result +1 ;
            }
        })
    }
        //console.log(result);
        return result;
    }


    return (
        <div className='PartNoteFooter'>
            <p className='footer'>{props.selectedNoteId}.{props.part}</p>
            {(props.authData.modulesName[1].status || (props.authData.userRole[0].role_id === 1)) ? <button className="troubles" onClick={onClickTroubles}></button>  : null}
            
            {(props.authData.modulesName[1].status || (props.authData.userRole[0].role_id === 1)) ? <sub className='count'>{countTroubles()}</sub>  : null}
            {(props.authData.modulesName[6].status || (props.authData.userRole[0].role_id === 1)) ? <button className="folderer" onClick={onClickFolderer}></button> : null }
        </div>
    )
};

export default PartNoteFooter;